'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import Image from '@/components/Image';
import AnimatedSubmitButton from '@/components/shared/AnimatedSubmitButton';
import { Typography } from '@/components/shared/Typography';
import { CalendlyCardDto } from '@/components/WebsiteProdPage/ScheduleMeeting/types';
import { useModal } from '@/hooks/useModal';
import css from './style.module.scss';
interface Props {
  data: CalendlyCardDto;
  className?: string;
  variant: 'calendly-first' | 'calendly-second';
}
const MeetingBlock: FC<Props> = t0 => {
  const $ = _c(29);
  const {
    data,
    className,
    variant
  } = t0;
  const {
    openModal
  } = useModal();
  const t1 = variant === "calendly-second" && css.isDark;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = clsx(css.card, className, t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.title) {
    t3 = <Typography uppercase={true} variant="h5" tag="h3" className={css.title}>{data.title}</Typography>;
    $[3] = data.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.description) {
    t4 = <Typography variant="body-m" tag="p" className={css.description}>{data.description}</Typography>;
    $[5] = data.description;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={css.ctaDotIcon}>•</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== openModal) {
    t6 = () => openModal("CALENDAR_BOOKING");
    $[8] = openModal;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = data.buttonLabel || "Schedule a meeting";
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <AnimatedSubmitButton startIconComponent={t5} wrapperClassName={css.ctaBtn} onClick={t6}>{t7}</AnimatedSubmitButton>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== data.founderName) {
    t9 = <Typography variant="body-m" tag="p">{data.founderName}</Typography>;
    $[13] = data.founderName;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== data.founderPosition) {
    t10 = <Typography variant="body-s" tag="p" className={css.founderPosition}>{data.founderPosition}</Typography>;
    $[15] = data.founderPosition;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image className={css.image} src="/assets/images/website-prod-page/schedule-meeting/yaroslav-full.webp" width={290} height={225} alt="" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11) {
    t13 = <div className={css.imageWrapper}>{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t8) {
    t14 = <div className={t2}>{t3}{t4}{t8}{t13}</div>;
    $[23] = t13;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
export default MeetingBlock;